function performCommonDoubleRoomCheck(travelerNumber:number, doubleRoomAmount:number, singleRoomAmount:number, mixedRoomAmount:number): boolean {
    return travelerNumber !== (doubleRoomAmount * 2) + singleRoomAmount + mixedRoomAmount;
}
function performSharedDoubleRoomCheck(travelerNumber:number, doubleRoomAmount:number, singleRoomAmount:number, mixedRoomAmount:number): boolean {
    const checkSum = ((doubleRoomAmount * 2) + singleRoomAmount + mixedRoomAmount);
    return travelerNumber > checkSum || travelerNumber < checkSum - doubleRoomAmount;
}

export function validateTravelerAndRooms(travelerNumber:number, doubleRoomAmount:number, singleRoomAmount:number, mixedRoomAmount:number, hasSharedDoubleRoom:boolean): boolean {
    let hasError;

    if (!travelerNumber) {
        hasError = true;
    } else if (!doubleRoomAmount && !singleRoomAmount && !mixedRoomAmount) {
        hasError = true;
    } else if (hasSharedDoubleRoom) {
        hasError = performSharedDoubleRoomCheck(travelerNumber, doubleRoomAmount, singleRoomAmount, mixedRoomAmount);
    } else {
        hasError = performCommonDoubleRoomCheck(travelerNumber, doubleRoomAmount, singleRoomAmount, mixedRoomAmount);
    }

    return hasError;
}
